const BaseOrganic = require('./common/base-organic');
const $ = require('cash-dom');
const QuickNav = require('./components/quick-nav');
const SmoothScroll = require('./components/smooth-scroll');

$(function () {
  BaseOrganic.init();
  QuickNav.init();
  SmoothScroll.init();
});
